import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityEntInfoVO } from '../Type/PackEntityEntInfoVO'

interface DataModel {
	cid?: string
}

/**
 *	获取企业的基本信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.cid] 企业id
 */

export function info(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityEntInfoVO>
export function info(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityEntInfoVO extends { msg: unknown } ? PackEntityEntInfoVO['msg'] : undefined>
export function info(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { cid } = data
	return net('/frontApi/ent/info', {
		method: 'post',
		params: {
			cid,
		},

		...(options || {}),
	})
}
